module.exports = __webpack_public_path__ + "fonts/icomoon.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/icomoon.ttf
// module id = ./node_modules/@ps/common-core/dist/fonts/icomoon.ttf
// module chunks = 1